@if ($page(); as page) {
  @if (page.template) {
    <ng-container [ngSwitch]="page.template">
      <ng-container
        *ngSwitchCase="'ProductDetailsPageTemplate'"
        [ngTemplateOutlet]="ProductDetailsPageTemplate"
      >
      </ng-container>
      <ng-container
        *ngSwitchCase="'ErrorPageTemplate'"
        [ngTemplateOutlet]="ErrorPageTemplate"
      >
      </ng-container>
    </ng-container>
  }
}

<!-- -------------------------- ProductDetailsPageTemplate --------------------------- -->
<ng-template #ProductDetailsPageTemplate>
  @if ($pageSlots(); as pageSlots) {
    <div class="spacing-container">
      <div class="product-details">
        @for (slot of pageSlots; track $index) {
          <section
            [attr.position]="slot.position"
            [class]="slot.position"
            [class.page-fold]="slot === $pageFold()"
            [class.has-components]="slot.components?.component?.length"
            [boelsSlotDecorator]="slot.properties"
          >
            <ng-template #slotsRenderer></ng-template>
          </section>
        }
      </div>
    </div>
  }
</ng-template>
<!-- -------------------------- ErrorPageTemplate --------------------------- -->
<ng-template #ErrorPageTemplate>
  @if ($pageSlots(); as pageSlots) {
    @for (slot of pageSlots; track $index) {
      <section
        [attr.position]="slot.position"
        [class]="slot.position"
        [class.page-fold]="slot === $pageFold()"
        [class.has-components]="slot.components?.component?.length"
        [boelsSlotDecorator]="slot.properties"
      >
        <ng-template #slotsRenderer></ng-template>
      </section>
    }
  }
</ng-template>
